import { translate } from '../../../../utils/i18n';
import AgenticToolApprovalModal from './agentic_tool_approval_modal/agentic_tool_approval_modal';
import AgenticToolRejectionModal from './agentic_tool_rejection_modal/agentic_tool_rejection_modal';
import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.js';

const i18n = {
  DEFAULT_DESCRIPTION: translate('AgenticToolApprovalFlow.defaultDescription', 'Duo Workflow wants to execute a tool. Do you want to proceed?')
};
const MODAL_TYPES = {
  APPROVAL: 'approval',
  REJECTION: 'rejection'
};
var script = {
  name: 'AgenticToolApprovalFlow',
  components: {
    AgenticToolApprovalModal,
    AgenticToolRejectionModal
  },
  props: {
    /**
     * Controls the visibility of the approval flow
     */
    visible: {
      type: Boolean,
      required: true
    },
    /**
     * Details about the tool to be executed
     * @property {string} name - The name of the tool
     * @property {Object} parameters - The parameters to be passed to the tool
     */
    toolDetails: {
      type: Object,
      required: false,
      default: () => ({}),
      validator: value => {
        return typeof value === 'object' && value !== null;
      }
    },
    /**
     * Custom description text for the approval request
     */
    description: {
      type: String,
      required: false,
      default: i18n.DEFAULT_DESCRIPTION
    }
  },
  data() {
    return {
      currentModal: MODAL_TYPES.APPROVAL
    };
  },
  computed: {
    showApprovalModal() {
      return this.visible && this.currentModal === MODAL_TYPES.APPROVAL;
    },
    showRejectionModal() {
      return this.visible && this.currentModal === MODAL_TYPES.REJECTION;
    }
  },
  watch: {
    visible(newVal) {
      if (!newVal) {
        this.currentModal = MODAL_TYPES.APPROVAL;
      }
    }
  },
  methods: {
    handleApprove() {
      /**
       * Emitted when the user approves the tool execution
       */
      this.$emit('approve');
    },
    handleInitialDeny() {
      this.currentModal = MODAL_TYPES.REJECTION;
    },
    handleForceDeny() {
      this.$emit('deny', null);
    },
    handleRejectionSubmit(message) {
      /**
       * Emitted when the user denies the tool execution with an optional reason
       * @param {string|null} reason - The rejection reason provided by the user
       */
      this.$emit('deny', message);
    },
    handleBack() {
      this.currentModal = MODAL_TYPES.APPROVAL;
    }
  },
  i18n
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-testid":"agentic-tool-approval-flow"}},[_c('agentic-tool-approval-modal',{attrs:{"visible":_vm.showApprovalModal,"tool-details":_vm.toolDetails,"description":_vm.description},on:{"approve":_vm.handleApprove,"deny":_vm.handleInitialDeny,"deny-force":_vm.handleForceDeny}}),_vm._v(" "),_c('agentic-tool-rejection-modal',{attrs:{"visible":_vm.showRejectionModal},on:{"submit":_vm.handleRejectionSubmit,"back":_vm.handleBack}})],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
export { i18n };
